import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ISnListResponse, ISnListQueryParameters } from '@lib/api';
import { SnIotDefender } from '@lib/api/entities';

@Injectable({ providedIn: 'root' })
export class SnIotDefenderAPI {
  constructor(private readonly _httpClient: HttpClient) {}

  public getList(params?: ISnListQueryParameters): Observable<ISnListResponse<SnIotDefender>> {
    return this._httpClient.get('/api/iot_defender/', { params }).pipe(
      map((response: any) => ({
        count: response.count,
        totalPages: response.totalPages,
        results: response.results.map((defender) => new SnIotDefender(defender)),
      })),
    );
  }

  public get(id: string): Observable<SnIotDefender> {
    return this._httpClient.get<SnIotDefender>(`/api/iot_defender/${id}`);
  }

  public metrics(params: any): Observable<any> {
    return this._httpClient.get('/api/iot_defender/metrics/', { params });
  }
}
